import { Container, Row, Col, Card } from "react-bootstrap";
import "./about.css";
import "./OurPurpose.css";
import Moulding from "./Moulding";
import { FaCheck } from "react-icons/fa";
import settingsLogo from "../../../assets/thumbnails/settingsLogo.png";
import ideaLogo from "../../../assets/thumbnails/idea.png";
// import aboutVideo from "../../../assets/about-video.mp4";

export default function About() {
  const points = [
    "ISO 9001:2015 certified company",

    "1500+ projects completed across North East India.",

    "Material Testing Lab in Howly, ISO/IEC 17025:2017 accredited.",
    "Committed to Quality, Innovation, and Excellence.",
  ];

  const TargetIcon = ({ size = 28, color = "currentColor" }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  );

  const GanttChartIcon = ({ size = 28, color = "currentColor" }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 6h10" />
      <path d="M6 12h9" />
      <path d="M4 18h8" />
      <path d="M12 2v20" />
    </svg>
  );

  return (
    <>
      <section id="who_we_are">
        <div className="pt-4  about-container">
          <Row className="about-row">
            <Col className="left-column-about" xs={12} sm={12} md={6} lg={6}>
              <h2 className="ourteam-heading p-0">Who we are?</h2>

              <h1 className="headline">Excellence in Every Brick We Lay</h1>

              <p className="left-para">
                SPIRENT INDIA INFRATECH PVT. LTD is leading infrastructure
                engineering consulting company that delivers design, planning,
                engineering consulting, construction management solution for and
                end-to-end solutions in building construction and interior
                decoration and material testing as well.{" "}
              </p>

              <div className="about-card">
                <ul className="custom-list">
                  {points.map((p, i) => (
                    <li key={i}>
                      <span className="tick-icon">
                        <FaCheck className="icon" />
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col className="right-column-about" xs={12} sm={12} md={6} lg={6}>
              <Moulding />
            </Col>
          </Row>
        </div>
      </section>

      {/* PURPOSE SECTION HEADING */}

      <section id="our_purpose" className="spirent-purpose" aria-label="Our purpose">
        <div className="purpose-section">
          <div className="our-services-heading-container pt-5">
            <h2 className="ourteam-heading">Our Purpose</h2>
            <p>
              We work with a clear mission and a strong vision that guide every
              project we handle. Our goal is to deliver the best quality,
              on-time results, and long-lasting value for our clients.
            </p>
          </div>
          {/* <div className="purpose-top">
            <h2 className="ourteam-heading">Our Purpose</h2>{" "}
            <p className="purpose-desc"></p>
          </div> */}

          <div className="purpose">
            <div className="purpose-wrapper">
              <div className="purpose-box">
                <div className="purpose-header">
                  <img
                    loading="lazy"
                    decoding="async"
                    src={settingsLogo}
                    className="purpose-icons"
                    alt="Mission Icon"
                  />
                  <h2>OUR MISSION</h2>
                </div>

                <ul className="purpose-list">
                  <li>
                    Offer complete civil and infrastructure services under one
                    platform.
                  </li>
                  <li>Focus on new ideas and high-quality results.</li>
                  <li>Complete work on time and within planned cost.</li>
                  <li>
                    Use modern technology for better quality and cost control.
                  </li>
                  <li>Always try to give more than customer expectations.</li>
                </ul>
              </div>

              <div className="middle-line"></div>

              <div className="purpose-box">
                <div className="purpose-header">
                  <img
                    loading="lazy"
                    decoding="async"
                    src={ideaLogo}
                    className="purpose-icons"
                    alt="Vision Icon"
                  />
                  <h2>OUR VISION</h2>
                </div>

                <ul className="purpose-list">
                  <li>Become one of the most trusted engineering firms.</li>
                  <li>Known for strong work quality and timely results.</li>
                  <li>
                    Always keep customer satisfaction at the highest level.
                  </li>
                  <li>Build strong and long-lasting structures.</li>
                  <li>Provide best service at a fair price.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
